import React from 'react'
import styled from '@emotion/styled'
import Section, { StyledSpan } from './Section'
import { LandingPageNumber } from '../../constants'
const VerifiedCheckyImage = __PATH_PREFIX__ + '/VerifiedChecky.svg'

const VehicleSection = ({ calculateViewChange, urlState, offer, prospect, navigatePageWithState, year = { displayName: '..' }, make = { displayName: '..' }, model = { displayName: '..' }, trim = { displayName: '..' }, mileage, canEdit }) => {
  const myprospect = prospect || (offer && offer.prospect) || {}
  const prospectVehicle = myprospect.vehicle || {}
  const vin = urlState.vin || (prospectVehicle && prospectVehicle.vin)

  let uniqueViewStr = year.yearId && make.makeId && model.modelId && 'uniqueViewStr:' + year.displayName + make.displayName + model.displayName + vin + mileage
  calculateViewChange('vehicle', uniqueViewStr)
  var trimInfo = (prospectVehicle.trimId !== trim.trimId && prospectVehicle.vehicleDescription) ? prospectVehicle.vehicleDescription.trim : trim.displayName;

  return (
    <Section title={'Vehicle'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: LandingPageNumber })}>
      <VerifiedByIconTextAndIconDiv>
        {prospect.vehicleBuildDataFlags && prospect.vehicleBuildDataFlags.cadsUsed && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan>Your Vehicle: </StyledSpan>
        {year.displayName + ' ' + make.displayName + ' ' + model.displayName + ' ' + trimInfo}
      </VerifiedByIconTextAndIconDiv>
      <br />
      <StyledSpan>VIN: </StyledSpan>
      {vin}
      <br />
      <StyledSpan>Mileage: </StyledSpan>
      {mileage}
    </Section>
  )
}

export default VehicleSection

const StyledCheckmarkIcon = styled.img`
  height: 14px;
  margin-right: 5px;
`

const VerifiedByIconTextAndIconDiv = styled.div`
  width: 100%;
  display: inline;
  vertical-align: bottom;
  text-align: center;
  height: 100%;
`
